import {
  LegendList,
  type LegendListProps,
  type LegendListRef,
  type LegendListRenderItemProps
} from '@legendapp/list/react'
import { forwardRef } from 'react'

const MessagesList = forwardRef<LegendListRef, LegendListProps>(({ style, ...props }, ref) => (
  <LegendList
    contentContainerStyle={{
      flexGrow: 1,
      gap: 16,
      padding: 16
    }}
    ref={ref}
    role='list'
    style={{
      flex: 1,
      ...style
    }}
    {...props}
  />
))

MessagesList.displayName = 'MessagesList'

export { MessagesList, LegendList, type LegendListRef, type LegendListRenderItemProps }
